export enum Decision {
  Accept = 'ACCEPT',
  Reject = 'REJECT',
}
